import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20silhouette%20of%20athletes%20in%20motion%2C%20abstract%20geometric%20patterns%20blending%20with%20stadium%20architecture%2C%20artistic%20and%20cinematic%20style%2C%20deep%20contrast%20between%20light%20and%20shadow%2C%20epic%20scale%2C%20professional%20sports%20photography%20aesthetic%20with%20moody%20ambient%20lighting&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="华体会官网 - 顶级体育娱乐平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
          <span className="text-xs md:text-sm text-background-50 font-medium">官方正版入口 · 安全可信赖</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
          华体会官网
          <br />
          <span className="text-accent-400">顶级体育娱乐平台</span>
        </h1>

        <p className="text-sm md:text-base text-background-50/80 max-w-2xl leading-relaxed mb-8">
          华体会官网为您提供安全稳定的官方正版入口，汇聚海量体育赛事、实时赔率与专业竞猜服务。
          注册即享丰厚福利，全天候客服保障您的每一次体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/football"
            className="px-8 py-3 bg-accent-500 text-background-50 font-semibold rounded-md hover:bg-accent-600 transition-all duration-300 whitespace-nowrap text-sm md:text-base"
          >
            立即体验
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap text-sm md:text-base"
          >
            了解更多
          </Link>
        </div>

        <div className="grid grid-cols-3 gap-6 md:gap-12 mt-12">
          {[
            { value: '1000+', label: '每日赛事' },
            { value: '500万+', label: '活跃会员' },
            { value: '7×24h', label: '客服在线' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}